<!--
 * @Date: 2023-01-28 12:08:36
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2023-02-04 14:40:06
 * @FilePath: \nicee-web-tw\src\activities\spring-festival\preliminary-round.vue
 * @Description: 初赛阶段
-->
<template>
  <div class="preliminary-round">
    <Chat
      :activityData="activityData"
      :rankList="rankList"
      @refresh="refresh"
    ></Chat>
    <div class="preliminary-round-main">
      <div class="content">
        <img
          class="img-header"
          src="./images/preliminary-round-header.png"
          alt=""
        />
        <div class="rules-box">
          <div class="jewel-title">
            <img class="jewel" src="./images/jewel.png" alt="" />
            <span>初賽活動規則</span>
          </div>
          <div class="content-title">
            -補選時間：2023/2/4 0:00 - 2023/2/8 24:00
          </div>
          <p class="content">
            活動規則：在初賽階段，由補選階段所入圍的40名陪玩師進行pk，根據初賽階段內每位陪玩師的火力值大小進行排名，最後選擇排名前八名陪玩師進入最終的決賽階段。
          </p>
          <div class="content-title">火力值獲取來源：</div>
          <p class="content">
            (1)陪玩師在初賽階段中可獲得與所完成的訂單實付金額相同數值的火力值；<br />
            (2)陪玩師在初賽階段中可獲得與完成的禮物訂單實付金額2倍的火力值；
            *【應援票】作為特殊道具可為陪玩師增加 50 火力值<br />
            (3)用戶選擇心儀的陪玩師發送彈幕加油打氣：普通彈幕可為陪玩師增加 6
            火力值/條，置頂彈幕可為陪玩師增加 ≥ 1520火力值/ 條 。<br />
            活動獎勵：點擊福袋右側「盛典獎勵說明」處即可查看
          </p>
        </div>
        <div class="jewel-title rank-list-title">
          <img class="jewel" src="./images/jewel.png" alt="" />
          <span>盛典火力榜</span>
        </div>
        <div class="rank-list-1">
          <button class="btn-record" @click="showGiftList">投票紀錄</button>
          <div class="ranking-item ranking-1">
            <div class="avatar-box" @click="toPlayerDetail(rankList[1])">
              <div class="avatar-b">
                <img
                  class="avatar"
                  :src="rankList[1] ? rankList[1].avatarUrl : ''"
                  alt=""
                />
              </div>

              <img
                class="avatar-border"
                src="./images/preliminary-round-no2.png"
                alt=""
              />
            </div>
            <div class="rank-info">
              <span class="user-name">{{
                rankList[1] ? rankList[1].nickname : ''
              }}</span>
              <span class="user-uuid"
                >uid:{{ rankList[1] ? rankList[1].userUuid : '' }}</span
              >
              <span class="user-fire">
                <img src="./images/fire.png" alt="" />
                火力值：
                {{ rankList[1] ? formatScore(rankList[1].score) : '' }}
              </span>
            </div>

            <button
              class="btn-vote"
              :class="{
                active:
                  rankList[1] &&
                  rankList[1].userUuid &&
                  rankList[1].userUuid != userInfo.uuid
              }"
              @click="handleVote(rankList[1])"
            >
              投票
            </button>
          </div>
          <div class="ranking-item ranking-2">
            <div class="avatar-box" @click="toPlayerDetail(rankList[0])">
              <div class="avatar-b">
                <img
                  class="avatar"
                  :src="rankList[0] ? rankList[0].avatarUrl : ''"
                  alt=""
                />
              </div>
              <img
                class="avatar-border"
                src="./images/preliminary-round-no1.png"
                alt=""
              />
            </div>
            <div class="rank-info">
              <span class="user-name">{{
                rankList[0] ? rankList[0].nickname : ''
              }}</span>
              <span class="user-uuid"
                >uid:{{ rankList[0] ? rankList[0].userUuid : '' }}</span
              >
              <span class="user-fire">
                <img src="./images/fire.png" alt="" />
                火力值：
                {{ rankList[0] ? formatScore(rankList[0].score) : '' }}
              </span>
            </div>
            <button
              class="btn-vote"
              :class="{
                active:
                  rankList[0] &&
                  rankList[0].userUuid &&
                  rankList[0].userUuid != userInfo.uuid
              }"
              @click="handleVote(rankList[0])"
            >
              投票
            </button>
          </div>
          <div class="ranking-item ranking-3">
            <div class="avatar-box" @click="toPlayerDetail(rankList[2])">
              <div class="avatar-b">
                <img
                  class="avatar"
                  :src="rankList[2] ? rankList[2].avatarUrl : ''"
                  alt=""
                />
              </div>
              <img
                class="avatar-border"
                src="./images/preliminary-round-no3.png"
                alt=""
              />
            </div>
            <div class="rank-info">
              <span class="user-name">{{
                rankList[2] ? rankList[2].nickname : ''
              }}</span>
              <span class="user-uuid"
                >uid:{{ rankList[2] ? rankList[2].userUuid : '' }}</span
              >
              <span class="user-fire">
                <img src="./images/fire.png" alt="" />
                火力值：
                {{ rankList[2] ? formatScore(rankList[2].score) : '' }}
              </span>
            </div>
            <button
              class="btn-vote"
              :class="{
                active:
                  rankList[2] &&
                  rankList[2].userUuid &&
                  rankList[2].userUuid != userInfo.uuid
              }"
              @click="handleVote(rankList[2])"
            >
              投票
            </button>
          </div>
        </div>
        <div class="rank-list-2">
          <div class="rank-header">
            <span class="order">排名</span>
            <span class="user-name">用戶</span>
            <span class="user-uuid">uid</span>
            <span class="user-score">火力值</span>
            <span class="action"></span>
          </div>
          <div class="rank-item" v-for="index in 37" :key="index">
            <!-- <div class="user-info"> -->
            <span class="order" v-if="index + 3 > 8">{{ index + 3 }}</span>
            <div class="order" v-else>
              <img :src="getOrderIcon(index + 3)" alt="" />
            </div>

            <div class="user-name">
              <img
                class="avatar"
                :src="rankList[index + 2].avatarUrl"
                alt=""
                v-if="
                  rankList &&
                    rankList[index + 2] &&
                    rankList[index + 2].avatarUrl
                "
                @click="toPlayerDetail(rankList[index + 2])"
              />
              <img class="avatar" src="./images/empty.png" alt="" v-else />

              {{ rankList[index + 2] ? rankList[index + 2].nickname : '' }}
            </div>
            <span class="user-uuid">{{
              rankList[index + 2] ? rankList[index + 2].userUuid : ''
            }}</span>
            <span class="user-score">{{
              rankList[index + 2] ? formatScore(rankList[index + 2].score) : ''
            }}</span>
            <div class="action">
              <button
                class="btn-vote"
                :class="{
                  active:
                    rankList[index + 2] &&
                    rankList[index + 2].userUuid &&
                    rankList[index + 2].userUuid != userInfo.uuid
                }"
                @click="handleVote(rankList[index + 2])"
              >
                投票
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="my-rank" v-if="isPlayer && appendInfo.rankNum">
        <div>
          <span>
            距离排名上一位陪玩师差距：{{
              appendInfo.NewYearStage2EndDateNeedAmount
            }}收入
          </span>
        </div>
      </div>
      <el-dialog
        class="spring-festival-dialog-bg"
        :visible.sync="voteDialog"
        title="提示"
        :show-close="false"
        :append-to-body="true"
      >
        <div class="stepper-box">
          <div>
            您當前有{{ answerTickets }}張應援票，想要投給陪玩師

            <div style="display:flex;">
              {{ selectedPlayer ? selectedPlayer.nickname : '' }}
              <el-input-number
                v-model="giveGiftInfo.count"
                size="mini"
              ></el-input-number>
              張應援票
            </div>
          </div>
        </div>
        <div class="btn-box">
          <el-button
            class="btn-confirm"
            type="info"
            size="small"
            @click="voteDialog = false"
            >取消</el-button
          >
          <el-button
            class="btn-confirm"
            type="primary"
            size="small"
            @click="vote()"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <give-gift-list ref="giveGiftList"></give-gift-list>
    </div>
  </div>
</template>
<script>
import GiveGiftList from './give-gift-list';
import Chat from './chat.vue';
import { mapGetters } from 'vuex';
import no4 from './images/preliminary-round-no4.png';
import no5 from './images/preliminary-round-no5.png';
import no6 from './images/preliminary-round-no6.png';
import no7 from './images/preliminary-round-no7.png';
import no8 from './images/preliminary-round-no8.png';

export default {
  name: 'PreliminaryRound',
  components: {
    Chat,
    GiveGiftList
  },
  props: {
    activityData: {
      typeof: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      selectedPlayer: null,
      voteDialog: false,
      giveGiftInfo: {
        count: 1,
        giftId: 133,
        playerUserUuid: null,
        giftFrom: 'ACTIVITY'
      }
    };
  },
  watch: {},
  computed: {
    ...mapGetters([
      'userInfo'
      // 'masterInfo'
    ]),
    list() {
      try {
        return this.activityData.appendInfo.byElection || [];
      } catch (error) {
        return [];
      }
    },
    //獲獎排名
    rankList() {
      try {
        return this.activityData.appendInfo.NewYearStage2EndDate || [];
      } catch (error) {
        return [];
      }
    },
    appendInfo() {
      try {
        return this.activityData.appendInfo || {};
      } catch (error) {
        return {};
      }
    },
    // 是B端用户
    isPlayer() {
      return this.userInfo && this.userInfo.userKind === 'Player';
    },
    // 应援票
    answerTickets() {
      try {
        return this.activityData.attachment['133'] || 0;
      } catch (error) {
        return 0;
      }
    }
  },
  methods: {
    // 查看陪玩師詳情
    toPlayerDetail(userInfo) {
      if (userInfo && userInfo.userUuid) {
        this.$router.push({
          path: `/player-detail/${userInfo.userUuid}`
        });
      }
    },
    handleVote(userInfo) {
      if (
        userInfo &&
        userInfo.userUuid &&
        userInfo.userUuid != this.userInfo.uuid
      ) {
        this.selectedPlayer = userInfo;
        this.voteDialog = true;
      }
    },
    async vote() {
      if (this.answerTickets < this.giveGiftInfo.count) {
        this.$confirm({
          message:
            '抱歉，您當前所擁有的應援票道具數量不足，可通過購買福袋鑰匙或開啓福袋獲得哦',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          className: 'spring-festival-dialog-bg'
        }).then(() => {});
        return;
      }
      try {
        this.giveGiftInfo.playerUserUuid = this.selectedPlayer.userUuid;
        const { data } = await this.$http.post('/gift/send', this.giveGiftInfo);
        console.log('vote', data);
        this.refresh();
        this.$confirm({
          message: `投票成功！成功为${this.selectedPlayer.nickname}增加了${this
            .giveGiftInfo.count * 50}火力值`,
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true,
          className: 'spring-festival-dialog-bg'
        });
        this.refresh();
      } catch (error) {
        this.$message('投票失敗');
      }
    },
    formatScore(score) {
      if (score) {
        const num = Number(score);
        if (num > 9999) {
          return (num / 10000).toFixed(1) + '萬';
        } else {
          return num;
        }
      } else {
        return 0;
      }
    },
    getOrderIcon(index) {
      let icon = '';
      switch (index) {
        case 4:
          icon = no4;
          break;
        case 5:
          icon = no5;
          break;
        case 6:
          icon = no6;
          break;
        case 7:
          icon = no7;
          break;
        case 8:
          icon = no8;
          break;
        default:
          break;
      }
      return icon;
    },
    showGiftList() {
      this.$refs.giveGiftList.openDialog();
    },
    refresh() {
      this.$emit('refresh');
    }
  }
};
</script>
<style lang="scss" scoped>
.preliminary-round {
  .preliminary-round-main {
    font-size: 1.5rem;
    color: #e9cc95;
    width: 100.08rem;
    margin-top: 10.67rem;
    margin-bottom: 15.33rem;
    position: relative;
    background: #371c04;
    border: 1px solid #eabf7c;
    border-radius: 20px;
    .img-header {
      position: absolute;
      left: 50%;
      top: 0;
      transform: translate(-50%, -50%);
      width: 27.92rem;
      height: 6.92rem;
    }

    .jewel-title {
      display: flex;
      align-items: center;
      margin-bottom: 2.5rem;
      font-size: 2.33rem;
      .jewel {
        width: 1.67rem;
        margin-right: 1rem;
      }
    }
    .rules-box {
      padding: 0 4.42rem;
      margin-top: 9.17rem;
      padding-bottom: 11.75rem;
      .content-title {
        color: #fdd241;
        margin-bottom: 1.42rem;
        margin-top: 2.5rem;
      }
      .content {
        font-size: 1.5rem;
        line-height: 3.6rem;
      }
    }
    .rank-list-title {
      padding-left: 4.42rem;
    }

    .btn-vote {
      width: 6.42rem;
      height: 2.83rem;
      color: #855534;
      opacity: 0.6;
      background: #ffd240;
      border-radius: 1.2rem;
      &.active {
        opacity: 1;
      }
    }
    .rank-list-1 {
      // height: 459px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      // margin-top: 38px;
      position: relative;
      line-height: 4rem;
      .btn-vote {
        margin-top: 2rem;
      }
      .rank-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 1.25rem;
          height: 2rem;
        }
      }
      .btn-record {
        color: #fff2de;
        position: absolute;
        right: 3.08rem;
        top: 0;
        width: 12.83rem;
        height: 4.42rem;
        background-color: #ff5600;
        border-radius: 1rem;
      }

      .ranking-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .avatar-box {
          position: relative;
          margin-bottom: 2rem;
          .avatar-b {
            border-radius: 50%;
            overflow: hidden;
          }
          .avatar {
            object-fit: cover;
            max-width: 100%;
          }
          .avatar-border {
            position: absolute;
            width: 100%;
            top: 0;
          }
        }

        &.ranking-1 {
          .avatar-b {
            width: 15.25rem;
            height: 15.25rem;
            margin-top: 4.58rem;
            margin-left: 2.67rem;
          }

          .avatar-box {
            width: 20.5rem;
            height: 21.33rem;
          }
        }
        &.ranking-2 {
          // margin-bottom: 123px;
          .avatar-b {
            width: 21.92rem;
            height: 21.92rem;
            margin-top: 7.67rem;
            margin-left: 5.5rem;
          }
          .avatar-box {
            width: 33.08rem;
            height: 32.08rem;
          }
        }
        &.ranking-3 {
          .avatar-b {
            width: 15.08rem;
            height: 15.08rem;
            margin-top: 4.25rem;
            margin-left: 3.08rem;
          }

          .avatar-box {
            width: 21.5rem;
            height: 21rem;
          }
        }
      }
    }
    .rank-list-2 {
      border: 1px solid #5c340d;
      border-radius: 2rem;
      margin: 4.67rem 7.17rem 11.75rem;
      overflow: hidden;
      padding-bottom: 4rem;
      position: relative;

      .rank-item,
      .rank-header {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        .order,
        .user-name,
        .user-uuid,
        .user-score,
        .action {
          display: inline-block;
          width: 20%;
          text-align: center;
          flex: none;
        }

        .order {
          display: inline-block;
          text-align: center;
          font-size: 1.67rem;
          img {
            width: 5.33rem;
            height: 3.67rem;
          }
        }
        .user-score {
          width: 16%;
        }
        .avatar {
          width: 5.5rem;
          height: 5.5rem;
          border-radius: 50%;
          object-fit: cover;
          flex: none;
        }
        .user-name {
          // margin-left: 115px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24%;
          padding-right: 1.8rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .rank-header {
        height: 4.33rem;
        margin-bottom: 0;
        background-color: #532703;
        margin-bottom: 1.17rem;
      }
      .rank-item {
        height: 7.75rem;
        .user-name {
          justify-content: flex-start;
          img {
            margin-right: 1.33rem;
          }
        }
      }
    }
    .my-rank {
      display: flex;
      justify-content: center;
      position: absolute;
      bottom: 4rem;
      left: 50%;
      transform: translateX(-50%);
      > div {
        width: 56.33rem;
        height: 5.08rem;
        background: #613204;
        border: 1px solid #f8b151;
        border-radius: 1rem;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        line-height: 2rem;
      }
    }
  }
}
</style>
